export const iconFontAwesomeUsersPeopleUserDoctor = (
	<i className="fa-solid fa-user-doctor"></i>
);
